class LancamentoFilter {
    constructor($filter, $scope) {
        this.filter = {}
        this.$filter = $filter

        this.mesesReferencia = this.buildMeses()
        this.statusRevisao = [
            { codigo: 'nao_revisada', descricao: 'Não revisada' },
            { codigo: 'regularizar', descricao: 'Lançamento a regularizar' },
            { codigo: 'processo', descricao: 'Lançamento em processo fiscal' },
            { codigo: 'concluida', descricao: 'Revisão concluída' }
        ]

        $scope.$watch(() => this.filter, () => this.submit(), true)
    }

    $onInit() {
        this.ngModelCtrl.$render = () => {
            if (this.ngModelCtrl.$viewValue) {
                this.filter = this.ngModelCtrl.$viewValue
            } else {
                this.filter = {}
            }

            let today = new Date()

            this.filter.periodo = {
                inicial: new Date(today.getFullYear(), today.getMonth(), 1),
                final: today
            }
        }
    }

    submit() {
        if (this.form && this.form.$valid) {
            this.updateFilter()
        } else {
            this.ngModelCtrl.$setViewValue(null)
        }
    }

    updateFilter() {
        let filter = angular.copy(this.filter)

        cbk.deleteEmptyKeys(filter)

        if (filter.periodo) {
            if (filter.periodo.inicial)
                filter.emissaoInicial = filter.periodo.inicial.toISOString()

            if (filter.periodo.final)
                filter.emissaoFinal = filter.periodo.final.toISOString()
        }

        delete filter.periodo

        filter.referenciaExtrato = this.$filter('date')(filter.referenciaExtrato, 'yyyy-MM-dd')

        if (filter.numero || filter.numeroExtrato) {
            delete filter.emissaoInicial
            delete filter.emissaoFinal
        }

        this.ngModelCtrl.$setViewValue(filter)
    }

    buildMeses() {
        const today = new Date()

        let month = today.getMonth() + 1
        const dates = []

        for (let i = 1; i < 24; i++) {
            dates.push(new Date(today.getFullYear(), month, 1))
            month -= 1
        }

        return dates
    }
}

angular.module('eficienciaFiscalModule')
    .component('lancamentoFilter', {
        controller: ['$filter', '$scope', LancamentoFilter],
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
        <form class="fade-animation" name="$ctrl.form" ng-submit="$ctrl.submit()">
            <div class="row">
                <div class="form-group col-sm-8 col-lg-4">
                    <label>
                        Data de emissão
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.periodo = undefined"
                           ng-if="$ctrl.filter.periodo"></i>
                    </label>
                    <periodo-input ng-model="$ctrl.filter.periodo"></periodo-input>
                </div>
                <div class="form-group col-sm-4 col-lg-2">
                    <label>
                        Número NF-e
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.numero = undefined"
                           ng-if="$ctrl.filter.numero"></i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.numero" ng-model-options="{ debounce: 500 }">
                </div>
                <div class="form-group col-sm-6 col-lg-4">
                    <label>
                        Razão Social, CNPJ
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.emitente = undefined"
                           ng-if="$ctrl.filter.emitente"></i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.emitente" ng-model-options="{ debounce: 500 }">
                </div>
                <div class="form-group col-sm-3 col-lg-2">
                    <label>
                        Número do lançamento
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.numeroExtrato = undefined"
                           ng-if="$ctrl.filter.numeroExtrato"></i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.numeroExtrato" ng-model-options="{ debounce: 500 }">
                </div>
                <div class="form-group col-sm-3 col-lg-2">
                    <label>
                        Mês do extrato
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.referenciaExtrato = undefined"
                           ng-if="$ctrl.filter.referenciaExtrato"></i>
                    </label>
                    <select class="form-control" ng-model="$ctrl.filter.referenciaExtrato" 
                            ng-options="mes as (mes | date:'MMM/yyyy') for mes in $ctrl.mesesReferencia">
                        <option value="">...</option>
                    </select>
                </div>
                <div class="form-group col-sm-3 col-lg-3">
                    <label>
                        Status da revisão
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.revisaoStatus = undefined"
                           ng-if="$ctrl.filter.revisaoStatus != undefined"></i>
                    </label>
                    <select class="form-control" ng-model="$ctrl.filter.revisaoStatus">
                        <option ng-value="undefined">...</option>
                        <option ng-repeat="status in $ctrl.statusRevisao" value="{{ status.codigo }}">
                            {{ status.descricao }}
                        </option>
                    </select>
                </div>
                <div class="form-group col-sm-3 col-lg-2">
                    <label>
                        Receita Extrato
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.receitaExtrato = undefined"
                           ng-if="$ctrl.filter.receitaExtrato"></i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.receitaExtrato" ng-model-options="{ debounce: 500 }">
                </div>
                <div class="form-group col-sm-3 col-lg-3">
                    <label>
                        Status do extrato
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.pagoExtrato = undefined"
                           ng-if="$ctrl.filter.pagoExtrato != undefined"></i>
                    </label>
                    <select class="form-control" ng-model="$ctrl.filter.pagoExtrato">
                        <option ng-value="undefined">...</option>
                        <option ng-value="true">Pago</option>
                        <option ng-value="false">Não pago</option>
                    </select>
                </div>
                <div class="form-group col-sm-3 col-lg-2">
                    <label for="" class="hidden-xs">&nbsp;</label>
                    <button type="submit" class="btn btn-primary btn-block"><i class=" fa fa-refresh"></i> Atualizar</button>
                </div>
            </div>
        </form>
        `
    })
